import { useTranslation } from "react-i18next";
import { storedLocale } from "../../../../components/Authentication/util";
import { resolveApplicantDisplayName } from "../../../../common/util/displayName";
import "./ApplicantABOName.scss";

type Name = {
  givenName: string;
  familyName: string;
};
type Props = {
  displayName: string;
  localeDisplayName: string;
  localeName: Name;
  latinName: Name;
  nameFormat: string;
  privacyFlag: boolean;
  preferredLanguageCode: string;
  fontSize?: "small" | "normal" | "medium" | "big" | "huge" | "large";
  fontWeight?: "thin" | "regular" | "medium" | "bold";
};

const ApplicantABOName = (props: Props) => {
  const { t } = useTranslation(["common"]);
  const portalLocale = storedLocale().split("-")[0];

  const {
    displayName,
    localeDisplayName,
    localeName,
    latinName,
    nameFormat,
    privacyFlag,
    preferredLanguageCode,
    fontSize,
    fontWeight,
  } = props;

  const aboName = resolveApplicantDisplayName(
    displayName,
    localeDisplayName,
    localeName,
    latinName,
    nameFormat,
    privacyFlag,
    preferredLanguageCode,
    portalLocale,
    t,
  );

  return (
    <div
      className={`${fontSize ? `leaf-abo-name--${fontSize} ` : ""}${fontWeight ? `leaf-abo-name--${fontWeight}` : ""}`}
    >
      {aboName}
    </div>
  );
};

export default ApplicantABOName;
